import { Box, Stack, Typography } from '@mui/material'

/**
 * The band at the top of a page: what this page is, what it is scoped to, and
 * what you can do here.
 *
 * `scope` is for the control that names the record the page is showing — the
 * client picker on the Job Search pages, for instance. It sits beside the
 * title rather than above the content because it is part of the answer to
 * "what am I looking at", not a filter.
 *
 * Everything wraps rather than truncating. A header that ellipses a client's
 * name to protect its own layout has failed at the one job it has.
 */
export default function PageHeader({
  title,
  help,
  scope,
  actions,
}: {
  title: string
  help?: React.ReactNode
  scope?: React.ReactNode
  actions?: React.ReactNode
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      useFlexGap
      sx={{ flexWrap: 'wrap', rowGap: 1.5 }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
        <Typography variant="h4" component="h1">
          {title}
        </Typography>
        {help}
      </Stack>
      {scope}
      <Box sx={{ flexGrow: 1 }} />
      {actions && (
        <Stack direction="row" alignItems="center" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
          {actions}
        </Stack>
      )}
    </Stack>
  )
}
